module.exports = __webpack_public_path__ + "static/media/friendfinder.b0ccac79.gif";